let searchParams = {};

$(function () {
    // search box
    $(".tab-container-list li:first-child").addClass("active");
    $(".tab-content-list .tc_box:first-child").show();
    $(".tab-container-list li a").click(function (e) {
        e.preventDefault();
        $(this)
            .parents("li")
            .addClass("active")
            .siblings()
            .removeClass("active");
        const getIndex = $(this).parents("li").index();
        $(".tab-content-list .tc_box").hide().eq(getIndex).show();
    });

    if ($("#keyword").length) {
        let searchURL = $("#keyword").attr("data-url");

        $("#keyword").keyup(function () {
            var keyword = $(this).val();
            if (keyword.length < 3) return false;

            var formData = $("#frmSearch")
                .find(":not(input[name=location])")
                .serialize();

            $.ajax({
                type: "GET",
                url: searchURL,
                data: formData,
                success: function (data) {
                    $("#localitylist").show();
                    $("#localitylist").html(data);
                },
            });
        });

        $("body").click(function (e) {
            if (e.target.id != "localitylist") {
                $("#localitylist").show();
                $("#localitylist").html("");
            }
        });

        $("#frmSearch").submit(function (event) {
            event.preventDefault();

            const keyword = $(this).find("#keyword").val();

            $(this).parent().find('#anchor-store-locator').removeClass('activeLocation');

            delete searchParams.administrative;
            delete searchParams.locality;
            delete searchParams.location;
            delete searchParams.format;

            $('#frmAdvancedSearch').find('#administrative').val('');
            $('#frmAdvancedSearch').find('#locality').find("option:gt(0)").remove();

            searchParams['keyword'] = keyword;
            storeListingUrl.search = new URLSearchParams(searchParams).toString();

            getLocationList(storeListingUrl.toString());

            $(this).find("#keyword").blur();
        });
    }

    // show cities of selected state code start from here
    $(document).on('change', 'select#administrative', function(event) {
        const localityEl = $('select#locality');
        localityEl.find("option:gt(0)").remove();
        
        const selVal = $(this).val();

        delete searchParams.locality;
        delete searchParams.keyword;

        if (selVal.length) {
            let localityJson = localityEl.data('json');
            const localities = localityJson[selVal];

            if (typeof localities !== 'undefined') {
                Object.keys(localities).forEach(key => {
                    localityEl.append(`<option value="${key}">${localities[key]}</option>`);
                });
            }

            $('#keyword').val('');
            $('#anchor-store-locator').removeClass('activeLocation');
        }

        searchParams['administrative'] = selVal;
        storeListingUrl.search = new URLSearchParams(searchParams).toString();
        getLocationList(storeListingUrl.toString());
    });

    // search by state + city code start from here 
    $(document).on('change', 'select#locality', function(event) {
        const locality = $(this).val();

        delete searchParams.keyword;

        searchParams['locality'] = locality;
        storeListingUrl.search = new URLSearchParams(searchParams).toString();
        getLocationList(storeListingUrl.toString());
    });

    // sorting dropdown
    $(document).on("change", "#ratingOrder", function (event) {
        const ratingOrder = $(this).val();

        if (ratingOrder.length) {
            searchParams['ratingOrder'] = ratingOrder;
            storeListingUrl.search = new URLSearchParams(searchParams).toString();

            getLocationList(storeListingUrl.toString());
        }
    });

    // user location
    $(document).on('click', '#anchor-store-locator', function(event) {
        let ele = $(this);

        navigator.geolocation.getCurrentPosition(function (position) {
            const latLng = position.coords.latitude + "|" + position.coords.longitude;
            ele.find('#userLatLng').val(latLng);
            ele.addClass("activeLocation");

            $('#frmSearch').find('#keyword').val('');
            $('#frmAdvancedSearch').find('#administrative').val('');
            $('#frmAdvancedSearch').find('#locality').find("option:gt(0)").remove();

            delete searchParams.administrative;
            delete searchParams.locality;
            delete searchParams.keyword;

            searchParams['location'] = latLng;

            storeListingUrl.search = new URLSearchParams(searchParams).toString();

            getLocationList(storeListingUrl.toString());
        }, function (error) {
            console.log(error);
        }, {
            enableHighAccuracy: true
        });
    });

    // pagination
    $(document).on("click", ".page-link", function (event) {
        event.preventDefault();
        
        const paginationUrl = $(this).data('url');

        if (typeof paginationUrl !== 'undefined') {
            getLocationList($(this).data('url'));
        }
    });

    $("div.data-view-type > .active").trigger("click");

    // attribute js
    if ($(".attributeGroup").length) {
        $(".attributeGroup").on("click", function () {
            $(".attributeList").slideUp();
            var attrEl = $(this).next("div.attributeList");
            if (attrEl.is(":visible")) attrEl.slideUp();
            else attrEl.slideDown();
        });

        // attributes popup js
        $("#show-more-srvc").click(function () {
            $(".modal-container ").show();
        });

        $(".modal-contents .btn-close").click(function () {
            $(".modal-container ").hide();
        });
    }

    // store detail page js
    if ($(".product_slider").length) {
        $(".product_slider").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }

    if ($(".customer_review").length) {
        $(".customer_review").slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        arrows:false,
                    },
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows:false,
                    },
                }
            ],
        });
    }

    if ($(".testimonials-slick-slide").length) {
        $(".testimonials-slick-slide").slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: "0px",
            centerMode: centerMode,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        slidesToShow: 2,
                    },
                },

                {
                    breakpoint: 768,
                    settings: {
                        centerMode: false,
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    var numItems = $(".lelt_right_spacer").length;
    if (numItems <= 2) {
        $(".lelt_right_spacer").addClass("two-slides");
    }

    // faq accordian js
    if ($(".course-accordion").length) {
        $(".course-accordion").click(function () {
            const getElement = $(this)
                .parents(".accordion-container")
                .siblings(".accordion-container");
            getElement
                .find(".course-accordion")
                .removeClass("active")
                .siblings(".course-panel")
                .slideUp();
            $(this)
                .toggleClass("active")
                .siblings(".course-panel")
                .slideToggle();
        });
    }
});

function getLocationList(targetUrl, formData = [], contentArea) {
    if (typeof contentArea === "undefined") {
        contentArea = "contentArea";
    }

    $.ajax({
        url: targetUrl,
        data: formData,
        type: "get",
        datatype: "json",
    })
        .done(function (data) {
            if (data.html) {
                $("#" + contentArea).html(data.html);

                $('#totalStoreCount').text(data.recordsInTxt);

                if ($(".map-view-store").hasClass("active")) {
                    $(".map-view-store").trigger("click");
                } else if ($(".grid-view-store").hasClass("active")) {
                    $(".grid-view-store").trigger("click") &&
                        $(".grid-view-store").show();
                }
            }
        })
        .fail(function (jqXHR, textStatus, thrownError) {
            console.log(thrownError);
        });
}
